export const useTranslations = () => {
  // how detect lang?
  const lang = 'pl'
  //from window
  const translations = window?.xTalkTranslation || []
  const t = (key) => {
    if (!translations.widget[lang][key]) {
      return key
    }
    return translations.widget[lang][key]
  }
  return {
    lang,
    allTranslations: translations,
    t
  }
}
